/**
 * Represents a picture.
 */
class Picture {
  static getMidSizePicUrl(picid) {
    return this.getPicUrl(picid, 640);
  }

  static getThumbnailUrl(picid) {
    return this.getPicUrl(picid, 160);
  }

  static toThumbnailUrls(picids) {
    return (picids ?? []).map(picid => this.getThumbnailUrl(picid));
  }

  static getPicUrl(picid, size) {
    return (size && `/pic/${picid}/${size}`) || `/pic/${picid}`;
  }

  static get defaultPic() {
    return '/images/blueberries.jpg';
  }

  static get defaultThumbnailPicUrl() {
    return '/images/blueberries_thumbnail.jpg';
  }
}

export { Picture };
